import { render, staticRenderFns } from "./RegistrantInfo.vue?vue&type=template&id=6e502e6e&scoped=true&"
import script from "./RegistrantInfo.vue?vue&type=script&lang=js&"
export * from "./RegistrantInfo.vue?vue&type=script&lang=js&"
import style0 from "./RegistrantInfo.vue?vue&type=style&index=0&id=6e502e6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e502e6e",
  null
  
)

export default component.exports